import { IndicationSummaryGetResponse } from '@lio/api-types';
import { LoginSource, LoginView, RegistrationPrefill, RegistrationRole } from '@pages/Login/constants';
import { PresetSignUpWrapper } from '@pages/Login/SignUpView/PresetSignUpWrapper';
import { RegistrationRoleSelectionView } from '@pages/Login/SignUpView/RegistrationRoleSelectionView';
import { SignUpView } from '@pages/Login/SignUpView/SignUpView';

export const renderView = ({
  view,
  loginSource,
  indicationSummary,
  isApiPartnerIndication,
  isRoleSelectionRequested = false,
  selectedRole,
  registrationPrefill,
  onRoleSelect,
  onSelectDifferentRole,
  redirectUrl,
}: {
  view?: LoginView;
  loginSource: LoginSource;
  indicationSummary?: IndicationSummaryGetResponse;
  isApiPartnerIndication: boolean;
  isRoleSelectionRequested?: boolean;
  selectedRole?: RegistrationRole;
  registrationPrefill?: RegistrationPrefill;
  onRoleSelect: (role: RegistrationRole) => void;
  onSelectDifferentRole: () => void;
  redirectUrl?: string;
}) => {
  switch (view) {
    case LoginView.SIGNUP: {
      // A register link from an email is for a Brokerage user, so it skips the role choice. Its details
      // win over any context left from a saved redirect (an indication or preset login source).
      if (registrationPrefill) {
        return (
          <SignUpView
            loginSource={loginSource}
            registrationRole={RegistrationRole.BROKER_PRODUCER}
            registrationPrefill={registrationPrefill}
          />
        );
      }
      const shouldShowRoleSelection =
        loginSource === LoginSource.LOGIN ||
        (loginSource === LoginSource.INDICATION && (!isApiPartnerIndication || isRoleSelectionRequested));

      if (shouldShowRoleSelection) {
        if (!selectedRole) {
          return <RegistrationRoleSelectionView onRoleSelect={onRoleSelect} />;
        }
        return (
          <SignUpView
            loginSource={loginSource}
            indicationSummary={indicationSummary}
            registrationRole={selectedRole}
            onSelectDifferentRole={onSelectDifferentRole}
          />
        );
      }

      if (loginSource === LoginSource.INDICATION && isApiPartnerIndication) {
        return (
          <SignUpView
            loginSource={loginSource}
            indicationSummary={indicationSummary}
            registrationRole={RegistrationRole.BROKER_PRODUCER}
            onSelectDifferentRole={onSelectDifferentRole}
          />
        );
      }

      return (
        <PresetSignUpWrapper loginSource={loginSource} redirectUrl={redirectUrl}>
          <SignUpView loginSource={loginSource} indicationSummary={indicationSummary} />
        </PresetSignUpWrapper>
      );
    }
    default:
      return null;
  }
};
